export default __webpack_public_path__ + "static/media/Strap_Khaki.03b6e7ea.png";